export default {
    apiUrl: {
        //后台类目管理
        categoryUrl: {
            getListLevelBackendCategory: "/goods/backendCategory/getListLevelBackendCategory", //查询类目
            getListBackendCategoryAttr: "/goods/backendCategoryAttr/getListBackendCategoryAttr", //查询类目属性
            getSpuListBackendCategoryAttr: "/goods/backendCategoryAttr/getSpuListBackendCategoryAttr", //查询商品模板类目属性
            editBackendCategory: "/goods/backendCategory/editBackendCategory", //编辑类目名称
            addBackendCategory: "/goods/backendCategory/addBackendCategory", //添加类目
            cancelBackendCategory: "/goods/backendCategory/cancelBackendCategory", //删除类目
            addBackendCategoryAttr: "/goods/backendCategoryAttr/addBackendCategoryAttr", //添加类目属性
            addGoodsSpuBackendCategoryAttr: "/goods/backendCategoryAttr/addGoodsSpuBackendCategoryAttr", //添加商品模板类目属性
            findBackendCategoryAttrById: "/goods/backendCategoryAttr/findBackendCategoryAttrById", //查询单个类目属性规则
            editBackendCategoryAttr: "/goods/backendCategoryAttr/editBackendCategoryAttr", //修改单个类目属性规则
            cancelBackendCategoryAttr: "/goods/backendCategoryAttr/cancelBackendCategoryAttr", //删除单个类目属性规则
            getBackendCategoryAttrBySortNo: "/goods/backendCategoryAttr/getBackendCategoryAttrBySortNo", //属性规则排序
            getRecentlyCategoryList: "/goods/spu/getRecentlyCategoryList" //最近使用的类目
        },
        bfCategoryUrl: {
            getFrontendCategoryList: "/goods/frontendCategory/getFrontendCategoryList", //查询前台类目
            editBackendBfCategory: "/goods/frontendCategory/editFrontendCategory", //编辑前台类目名称
            addBackendBfCategory: "/goods/frontendCategory/addFrontendCategory", //添加前台类目
            cancelFrontendCategory: "/goods/frontendCategory/cancelFrontendCategory", //删除前台类目
            getBackendCategoryList: "/goods/frontendCategory/getBackendCategoryList", //查询前台绑定的后台类目列表
            addFrontBackCategory: "/goods/frontBackCategory/addFrontBackCategory", //绑定后台类目
            cancelFrontBackCategory: "/goods/frontBackCategory/cancelFrontBackCategory", //删除后台绑定类目
            addFrontendCategoryImage: "/goods/frontendCategory/addFrontendCategoryImage", //绑定图片
            cancelFrontendCategoryImage: "/goods/frontendCategory/cancelFrontendCategoryImage" //删除绑定图片
        },
        goodsTplUrl: {
            getListGoodsSpu: "/goods/spu/getListGoodsSpu", //查询列表
            listBrand: "/goods/brand/listBrand", //查询所属品牌
            getThreeBackendCategory: "/goods/backendCategory/getThreeBackendCategory", //查询商品类目
            getListSuitableAge: "/goods/suitableage/getSuitableAgeList", //适用年龄段
            addGoodsSpu: "/goods/spu/addGoodsSpu", //新增发布spu
            findGoodsSpuById: "/goods/spu/findGoodsSpuById", //查询商品spu
            editGoodsSpu: "/goods/spu/editGoodsSpu",
            cancelGoodsSpu: "/goods/spu/cancelGoodsSpu" //删除spu商品
        },
        brandUrl: {
            getBrandList: "/goods/brand/getBrandList", //查询品牌
            addBrand: "/goods/brand/addBrand", //添加品牌
            findBrandById: "/goods/brand/findBrandById", //查询单个品牌
            editBrand: "/goods/brand/editBrand", //编辑品牌
            cancelBrands: "/goods/brand/cancelBrands", //删除品牌
        },
        goodsUrl: {
            getListMerchantItemDto: "/goods/item/getListMerchantItemDto", //查询列表
            getStoreInfoList: "/merchant/storeInfo/getStoreInfoList", //  查询店铺列表
            listAll: "/goods/v2/item/listAll", //查询列表
            list: "/goods/v2/item/sku/list", //查询SKU
            getAllLeaves: "/goods/category/getAllLeaves", //获取类目列表
            freezeItem: "/goods/item/freezeItem", //冻结商品
            unFreezeItem: "/goods/item/unFreezeItem", //解冻结商品
            addIntegralRatio: "/goods/item/addIntegralRatio", //修改积分比例
            findIntegralRatio: "/goods/item/findIntegralRatio/", //查询积分比例
            /*获取库存预警员*/
            getLists: "/base/system/user/getList",
            /*物流信息*/
            getFreightTempleteList: "/merchant/freight/getList/",
            /*商品回显接口   第一个页面*/
            editItemFrist: "/goods/v2/item/",
            /*显示类目全路径*/
            fullPath: "/goods/category/fullPath/",
            /*获取品牌*/
            listBrand: "/goods/category/listBrand/",
            /*查询item属性*/
            attrQuery: "/goods/v2/item/attrQuery/",
            // 查看Item下SKU列表
            listSku: "/goods/v2/item/listSku/",
            getGoodsEntranceGoods: "/goods/entrance/getGoodsEntranceGoods",//分页查看可配置商品接口
            getGoodsEntranceStore: "/goods/entrance/getGoodsEntranceStore",//分页查询可配置店铺接口
            getGoodsEntranceByPage: "/goods/entrance/getGoodsEntranceByPage",//分页条件查询商品入口配置列表
            deleteGoodsEntrance: "/goods/entrance/delete",//删除商品详情入口配置
            stateGoodsEntrance: "/goods/entrance/state",//启用禁用商品入口接口
            getGoodsEntranceLogByPage: "/goods/entrance/log/getGoodsEntranceByPage",//查看商品入口操作日志
            getGoodsEntrance: "/goods/entrance/goodsEntrance",//查看商品入口配置详情
            editgoodsEntrance: "/goods/entrance/edit",//编辑商品入口配置
            addgoodsEntrance: "/goods/entrance/add",//新增商品入口配置
            batchUpdate:'/goods/goldRatio/batchUpdate',/* 批量修改权益金比例 */
            getByItemId:'/goods/goldRatio/getByItemId/',/* 获取商品权益金比例 */
            updateGoldRadio:'/goods/goldRatio/update',/* 修改权益金比例 */
            distributorCate:'/goods/v2/distributor/cate',//获取渠道商品类信息
            itemDistributorCate:'/goods/v2/item/distributor/cate',//获取商品的渠道商品类
            associateDistributorCates:'/goods/v2/batch/associate/distributor/cates',//商品批量关联渠道商品类
            getLabelEnum:'/goods/custom/get/label/enum',//获取定制商品商品标签枚举
            putItemLabel:'/goods/custom/put/item/label',//设置定制商品商品标签
            exportGoods:"/goods/v2/platform/item/export",   //导出现货商品
        },
        goodsSearchUrl: {
            defaultSearch: "/search/defaultWord", //新增默认搜索词
            hotSearch: "/search/hotWord", //新增热词
            defaultSearchList: "/search/defaultWords", //默认搜索词列表
            removeDefaultSearch: "/search/defaultWords/", //删除默认搜索词
            updateDefaultSearch: "/search/defaultWord", //更新默认搜索词
            updateHotSearch: "/search/hotWord", //修改热词
            hotSearchList: "/search/hotWords", //查看热词列表
            removeHotSearch: "/search/hotWords/", //删除热词
            userSearchList: "/search/searchStatistics/list", //用户搜索统计列表
            removeSensitive: "/search/searchStatistics", //移出敏感库
            removeToSensitive: "/search/searchStatistics", //移出至敏感库
            detailsList: "/search/searchStatistics/detail", //列表详情
        },
        ageManagement: {
            ageManagementList: "/goods/frontendCategory/getFrontendCategoryList", //获取类目结果
            setFirstAdvertisement: "/goods/frontendCategory/addAdSpace", //一级类目添加/修改广告位
            deleteAdvertisement: "/goods/frontendCategory/deleteAdSpace/", //删除广告位
            advertisementInformation: "/goods/frontendCategory/getAD/", //获取广告位信息
            secondCategoryBrand: "/goods/frontendCategory/secondLevel/getBindBrand/", //二级类目获取品牌
            thirdCategoryBrand: "/goods/frontendCategory/thirdLevel/getBind/", //三级类目获取绑定商品或类目信息
            addCategory: "/goods/frontendCategory/addFrontendCategory", //添加类目
            deleteCategory: "goods/frontendCategory/cancelFrontendCategory/", //删除类目
            editCategory: "goods/frontendCategory/editFrontendCategory", //编辑类目
            getBrandList: "goods/brand/getBrandList", //获取品牌列表
            addBindInformation: "/goods/frontendCategory/addBind/", //二级三级类目添加绑定信息           
            deleteBindInformation: "/goods/frontendCategory/deleteBind", //二级三级类目删除绑定信息
            getLevelCategory: '/goods/category/getLevelCategory/',
            addFrontendCategoryImage: "/goods/frontendCategory/addFrontendCategoryImage", //三级类目添加图片
            list: '/goods/v2/item/listAll', //商品列表
            importGoods: '/decorate/upload/importGoods', //文件批量导入商品
            cancelFrontendCategoryImage: '/goods/frontendCategory/cancelFrontendCategoryImage/', //给三级类目删除图片
            removeBindUrl:'/goods/frontendCategory/removeBindUrl/', //三级类目删除绑定连接
        },
        goldRatio:{
            goldRatioGet:'/goods/goldRatio/newtype/get/config',//获取商品新会员购物金比例配置
            goldRatioSet:'/goods/goldRatio/newtype/batchConfig',//批量插入或更新商品新会员购物金比例配置
            achievementTagAll:'/goods/v2/achievement/tag',//获取业绩标签信息
            achievementTagSet:'/goods/v2/batch/associate/achievementTags',//商品批量关联商品的业绩标签
            achievementTagGet:'/goods/v2/item/achievementTag',//获取商品的业绩标签
        }
    }
};